export const environment = {
  production: true,
  serverUrl: 'https://avemapi.galsd.com',
  trackUrl: '/api/v2',
  googleMapApiKey: 'AIzaSyBat7RasiQv_8CrmR9Ka79xEYqzt_fNnM0'
};
